import React, { PureComponent } from "react";
import DOMPurify from "dompurify";

import HighlightService from "../../../services/HighlightService";

/**
 * Render sanitized, optionally-highlighted rich text from an HTML string.
 * Used for FAQ answer bodies, but generic — works anywhere we accept user
 * HTML and want safe rendering.
 *
 * Props:
 *   html       : string  — raw HTML to render
 *   query      : string  — user search query (drives term highlights)
 *   bestSpan   : string  — optional AI-picked best matching span
 *   className  : string  — wrapping div className
 */
const PURIFY_CONFIG = {
    ALLOWED_TAGS: [
        "p", "br", "span", "strong", "b", "em", "i", "u", "s", "strike",
        "ol", "ul", "li", "blockquote", "pre", "code",
        "h1", "h2", "h3", "h4", "h5", "h6",
        "a", "img", "hr", "mark",
    ],
    ALLOWED_ATTR: ["href", "name", "target", "rel", "src", "alt", "width", "height", "class"],
    ALLOWED_URI_REGEXP: /^(?:https?:|mailto:|data:image\/)/i,
};

class RichTextView extends PureComponent {
    render() {
        const { html, query, bestSpan, className = "rte-view" } = this.props;
        if (!html) return null;

        // 1) Sanitize defensively — the backend also sanitizes on write but
        //    we never want a stored XSS to survive a single missed update.
        const clean = DOMPurify.sanitize(html, PURIFY_CONFIG);

        // 2) Highlight matching text. No-op when there's no query/span.
        const terms = HighlightService.termsFromQuery(query || "");
        const highlighted = (terms.length || bestSpan)
            ? HighlightService.highlightHtml(clean, { terms, span: bestSpan })
            : clean;

        return (
            <div
                className={className}
                dangerouslySetInnerHTML={{ __html: highlighted }}
            />
        );
    }
}

export default RichTextView;
